import React, {
  useEffect,
  useState,
  forwardRef,
} from "react";
import { Tree, TreeNode } from "react-organizational-chart";
import _ from "lodash";
import clsx from "clsx";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import BusinessIcon from "@mui/icons-material/Business";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Badge from "@mui/material/Badge";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDrag, useDrop } from "react-dnd";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { axiosFetch } from "../../../utils/AxiosFetch";
import Select from "react-select";
import Dialog from "@mui/material/Dialog";
import { CardContent, DialogTitle } from "@mui/material";
import CustomStyles from "../../../shared/DropdownCustomStyles";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import AddUserModal from "../../../shared/AddUserModal";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useDispatch, useSelector } from "react-redux";
import { fetchChartData } from "../../../redux/actions/structure.actions";
import { loadReportingManagers } from "../../../redux/actions/lookups.action";
import { SnackbarActions } from "../../../redux/actions/snackbar.actions";
import { change_team } from "../../../redux/actions/user.actions";
import "./Org.css"
import ChangeTeamModal from "../MyAccount/ChangeTeamModal";
import { CommonModal } from "../../../shared";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "white",
    display: "inline-block",
    borderRadius: 16,
    width: "max-content",
  },
  expand: {
    transform: "rotate(0deg)",
    marginTop: -10,
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.short,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: "#ECECF4",
  },
}));

function Organization({ org, onCollapse, collapsed }) {
  const dispatch = useDispatch();

  let managerList = useSelector(state => state);


  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openReprt, setOpenReprt] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [togglePopup, setTogglePopup] = React.useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [reportingmanagers, setReportingManagers] = useState([]);
  const [isPopupOpen, setisPopupOpen] = useState(false);
  const [deptName, setDeptName] = useState("");
  const [teamName, setTeamName] = useState("");
  const [reprtMngrId, setReptrMngrId] = useState("");

  let changeTeam_success = useSelector(state => state.changeTeam_Reducer.changeTeam)



  const handleTeamMembers = () => {
    // close menu
    handleClose();
    if (isPopupOpen) {
      setisPopupOpen(false);
    } else {
      setisPopupOpen(true);
    }
  };

  const fetchReportingManagers = () => {
    var req = {
      "departmentId": 0,
      "teamId": 0
    }
    axiosFetch({
      method: "post",
      url: "/lookup/reportingmanagers",
      requestConfig: req,
    })
      .then((res) => {
        if (res.status === 200) {
          setReportingManagers(res.data);

        }
        // else if (res.status === 400) {
        //   dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        // }
      })
      .catch((err) => console.error(err));
  };

  // useEffect(() => {
  //   fetchReportingManagers();
  // }, []);

  const handleClosePopup = () => {
    setOpen(false);
    setTogglePopup(null);
  };
  const handleClick = (event, tName, deptName, id) => {
    setAnchorEl(event.currentTarget);
    setDeptName(deptName)
    setTeamName(tName)
    setReptrMngrId(id)
    console.log(id)
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleReportingPopup = (e) => {
    handleClose();
    if (openReprt) {
      setOpenReprt(false);

    }
    else {
      setOpenReprt(true);

    }
    // setOpen(true);
    // setTogglePopup(e.currentTarget);
    // setAnchorEl(null);
  };

  useEffect(() => {
    if (changeTeam_success.data === "success") {
      dispatch(SnackbarActions(true, "success", "User's team changed successfully"))
    }
  }, [changeTeam_success])

  const changeReporting = (empId, reporterId) => {
    console.log(empId, reporterId)
    var req = {
      "userId": empId,
      "reportingPersonId": reporterId
    }
    // dispatch(change_team(req))

  };

  const [{ canDrop, isOver }, drop] = useDrop({
    accept: "account",
    drop: () => ({ data: org !== null ? org : "" }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });
  const isActive = canDrop && isOver;
  let backgroundColor = "white";
  if (isActive) {
    backgroundColor = "#ddffd2";
  } else if (canDrop) {
    backgroundColor = "#ffeedc";
  }
  const subtitle = (
    <div
      className="tooltip"
      title={`${org !== null && org.departmentName !== null ? org.departmentName : ""
        }`}
    >
      {org !== null && org.teamName !== undefined && org.teamName !== null
        ? org.teamName
        : ""}
      {org !== null &&
        org.departmentCode !== undefined &&
        org.departmentCode !== null
        ? org.departmentCode
        : ""}
    </div>
  );


  return (
    <div>
      {/* <Tooltip describeChild title={`${org !== null && org.departmentName !== null ? org.departmentName : ""}`}  arrow placement="bottom"> */}
      <Card
        variant="outlined"
        className={classes.root + " argus-card"}
        ref={
          JSON.parse(localStorage.getItem("argus_user")).usertype !== "Admin"
            ? null
            : drop
        }
        style={{ backgroundColor }}
      >
        <CardHeader
          avatar={
            <Badge
              style={{ cursor: "pointer" }}
              color="secondary"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              showZero
              invisible={!collapsed}
              overlap="circular"
              badgeContent={org !== null && _.size(org.members)}
              onClick={onCollapse}
            >
              <Avatar className={classes.avatar}
                sx={{
                  width: 50,
                  height: 50,
                }}
                alt={org ? org.firstName : ''}
                src={org && org.profilePhotoName ? `/api/uploads/image/show/${org.profilePhotoName}` : ''} />
            </Badge>
          }
          // title={org !== null && org.firstName + " " + org.lastName}
          // subheader={subtitle}
          action={JSON.parse(localStorage.getItem("argus_user")).usertype === "Admin" ?
            <IconButton className="org-action" size="small" onClick={(e) => handleClick(e, org.teamName, org.departmentName, org.id)}>
              <MoreVertIcon />
            </IconButton> : ""
          }
        />
        <CardContent>
          <Link to={`/users-profile/${org.id}`} style={{ cursor: "pointer", textDecoration: "none", color: "black" }} className="argus-org-title">{org !== null && org.firstName + " " + org.lastName}</Link>
          <p className="argus-org-content">{subtitle}</p>
        </CardContent>
        <Menu
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
        >
          {org.empNumber !== 0 ? <MenuItem onClick={() => handleReportingPopup()}>
            <ListItemIcon>
              <BusinessIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Change Team" />
          </MenuItem> : ""}
          <MenuItem onClick={() => handleTeamMembers()}>
            <ListItemIcon>
              <AccountBalanceIcon color="secondary" />
            </ListItemIcon>
            <ListItemText primary="Add Team Member" />
          </MenuItem>
        </Menu>
        <IconButton
          size="small"
          onClick={onCollapse}
          className={clsx(classes.expand, {
            [classes.expandOpen]: !collapsed,
          })}
        >
          <ExpandMoreIcon />
        </IconButton>
      </Card>
      <AddUserModal openModal={isPopupOpen} addUser={handleTeamMembers} teamName={teamName} departmentName={deptName} reportingManagerId={reprtMngrId} />
      <ChangeTeamModal open={openReprt} handleClick={handleReportingPopup} pageData={org} count={org.members !== undefined ? org.members.length : 0} />
      {/* <CommonModal module="OrganizationChart" openModal= {openReprt} handlepopupState = {handleReportingPopup} selectedEmployeeData={org}/> */}
      {/* </Tooltip> */}
      {/* <Dialog
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
     onClose={handleClosePopup} open={open}>
      <h3>Select Reporting Manager</h3>
        <Select
          styles={CustomStyles}
          // defaultValue={selectedOption}
          onChange={setSelectedOption}
          options={managerList}
        />
        <IconButton>
          {selectedOption !== null ? (
            <DoneIcon
              onClick={() =>
                changeReporting(selectedOption.value, org.empNumber)
              }
            />
          ) : (
            <CloseIcon />
          )}
        </IconButton>
      </Dialog> */}
      {/* <Modal
        open={open}
        onClose={handleClosePopup}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <Select
        // defaultValue={selectedOption}
        onChange={setSelectedOption}
        options={reportingmanagers}
      />
        </Box>
      </Modal> */}
    </div>
  );
}
function Leaf({ a }) {
  const classes = useStyles();
  return (
    a ?
      <div>
        <Avatar className={classes.avatar}
          sx={{
            width: 50,
            height: 50,
          }}
          alt={a.firstName}
          src={a && a.profilePhotoName ? `http://localhost:3000/api/uploads/image/show/${a.profilePhotoName}` : ''} />
        <div>{a.firstName}</div>
        <div style={{ clear: "both" }} />
      </div>
      : ''
  );
}
function Account({ a }) {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openReprt, setOpenReprt] = React.useState(false);
  const [togglePopup, setTogglePopup] = React.useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [reportingmanagers, setReportingManagers] = useState([]);
  const [isPopupOpen, setisPopupOpen] = useState(false);
  const [deptName, setDeptName] = useState("");
  const [teamName, setTeamName] = useState("");
  const [reprtMngrId, setReptrMngrId] = useState("");
  const open = Boolean(anchorEl);
  let changeTeam_success = useSelector(state => state.changeTeam_Reducer.changeTeam)


  const handleTeamMembers = () => {
    // close menu
    handleClose();
    if (isPopupOpen) {
      setisPopupOpen(false);
    } else {
      setisPopupOpen(true);
    }
  };

  const subtitle = (
    <div
      className="tooltip"
      title={`${a !== null && a.departmentName !== null ? a.departmentName : ""
        }`}
    >
      {a !== null && a.teamName !== undefined && a.teamName !== null
        ? a.teamName
        : ""}
      <br />
      {a !== null && a.departmentCode !== undefined && a.departmentCode !== null
        ? a.departmentCode
        : ""}
    </div>
  );

  const handleClosePopup = () => {
    setOpenReprt(false);
    setTogglePopup(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchReportingManagers = () => {
    var req = {
      "departmentId": 0,
      "teamId": 0
    }
    axiosFetch({
      method: "post",
      url: "/lookup/reportingmanagers",
      requestConfig: req,
    })
      .then((res) => {
        if (res.status === 200) {
          setReportingManagers(res.data);

        }
        // else if (res.status === 400) {
        //   window.location.href = "/";
        // }
        else if (res.status === 401) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        }
      })
      .catch((err) => console.error(err));
  };

  // useEffect(() => {
  //   fetchReportingManagers();
  // }, []);

  useEffect(() => {
    if (changeTeam_success.data === "success") {
      dispatch(SnackbarActions(true, "success", "User's Team Changed Succesfully"))
    }
  }, [changeTeam_success])

  const changeReporting = (dropingData, managerData) => {
    var req = {
      "userId": dropingData.id,
      "departmentId": managerData.departmentId,
      "teamId": managerData.teamId,
      "reportingPersonId": managerData.id
    }
    console.log(req)
    dispatch(change_team(req))

  };

  const classes = useStyles();
  const [{ isDragging }, drag] = useDrag({
    name: a.id,
    type: "account",
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult) {
        // alert(`You moved ${a.firstName} to ${dropResult.name}`);
        // window.location.href = "/orgchart";
        changeReporting(a, dropResult.data);
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0.4 : 1;

  const handleClick = (event, tName, deptName, id) => {
    setAnchorEl(event.currentTarget);
    setDeptName(deptName)
    setTeamName(tName)
    setReptrMngrId(id)
    console.log(id)
  };

  const handleReportingPopup = (e) => {
    handleClose();
    if (openReprt) {
      setOpenReprt(false);

    }
    else {
      setOpenReprt(true);

    }
    // setTogglePopup(e.currentTarget);
    // setAnchorEl(null);
  };

  return (
    <div>
      <Card
        variant="outlined"
        className={classes.root + " argus-card"}
        // drag is happening here
        ref={
          JSON.parse(localStorage.getItem("argus_user")).usertype !== "Admin"
            ? null
            : drag
        }
        style={{ cursor: "pointer", opacity }}
      >
        <CardHeader
          avatar={
            <Avatar className={classes.avatar}
              sx={{
                width: 50,
                height: 50,
              }}
              alt={a ? a.firstName : ''}
              src={a && a.profilePhotoName ? `/api/uploads/image/show/${a.profilePhotoName}` : ''} />
          }
          action={JSON.parse(localStorage.getItem("argus_user")).usertype === "Admin" ?
            <IconButton size="small"
              onClick={(e) => handleClick(e, a.teamName, a.departmentName, a.id)}
            >
              <MoreVertIcon />
            </IconButton> : ""
          }
        // title={a.firstName + " " + a.lastName}
        // subheader={subtitle}
        />
        <CardContent>
          <Link to={`/users-profile/${a.id}`} style={{ cursor: "pointer", textDecoration: "none", color: "black" }} className="argus-org-title">{a.firstName + " " + a.lastName}</Link>
          <p className="argus-org-content">{subtitle}</p>
        </CardContent>
      </Card>
      <Menu open={open} anchorEl={anchorEl} onClose={handleClose}>
        <MenuItem onClick={() => handleReportingPopup()}>
          <ListItemIcon>
            <BusinessIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Change Team" />
        </MenuItem>
        <MenuItem onClick={() => handleTeamMembers()}>
          <ListItemIcon>
            <AccountBalanceIcon color="secondary" />
          </ListItemIcon>
          <ListItemText primary="Add Team Member" />
        </MenuItem>
      </Menu>
      <AddUserModal openModal={isPopupOpen} addUser={handleTeamMembers} teamName={teamName} departmentName={deptName} reportingManagerId={reprtMngrId} />
      {/* <Dialog
        onClose={handleClosePopup}
        open={open}
        style={{
          padding: "92px !important",
          // backgroundColor: "#fff !important",
        }}
      >
        <DialogTitle className="modal-heading">
          Select Reporting Manager
        </DialogTitle>
        <Select
          // styles={CustomStyles}
          // defaultValue={selectedOption}
          onChange={setSelectedOption}
          options={reportingmanagers}
        />
        <IconButton>
          {selectedOption !== null ? (
            <DoneIcon
              onClick={() => changeReporting(selectedOption.value, a.empNumber)}
            />
          ) : (
            <CloseIcon />
          )}
        </IconButton>
      </Dialog> */}
      <ChangeTeamModal open={openReprt} handleClick={handleReportingPopup} pageData={a} count={a.members !== undefined ? a.members.length : 0} />
      {/* <CommonModal module="OrganizationChart" openModal= {openReprt} handlepopupState = {handleReportingPopup} selectedEmployeeData={a}/> */}

    </div>
  );
}
// function Product({ p }) {
//   const classes = useStyles();
//   return (
//     <Card variant="outlined" className={classes.root}>
//       <CardContent>
//         <Typography variant="subtitle2">{p.name}</Typography>
//       </CardContent>
//     </Card>
//   );
// }

function Node(props) {
  const [collapsed, setCollapsed] = React.useState(
    props.o !== null ? props.o.collapsed : ""
  );

  const handleCollapse = () => {
    setCollapsed(!collapsed);
  };
  React.useEffect(() => {
    if (props.o !== null) {
      props.o.collapsed = collapsed;
    }
  });
  const T = props.parent
    ? TreeNode
    : (props) => (
      <Tree
        {...props}
        lineWidth={"2px"}
        lineColor={"#bbc"}
        lineBorderRadius={"12px"}
      >
        {props.children}
      </Tree>
    );
  return collapsed ? (
    <T
      label={
        <Organization
          org={props.o}
          onCollapse={handleCollapse}
          collapsed={collapsed}
        />
      }
    />
  ) : (
    <T
      label={
        <Organization
          org={props.o}
          onCollapse={handleCollapse}
          collapsed={collapsed}
        />
      }
    >
      {props !== undefined &&
        props.o !== null &&
        _.map(props.o.members, (a) => {
          if (a.members.length === 0) {
            return (
              // <Leaf a={a} fetchChartData={props.fetchChartData} />
              <TreeNode
                label={<Account a={a} fetchChartData={props.fetchChartData} />}
              ></TreeNode>
            );
          }
        })}
      {props.o !== null &&
        _.map(props.o.members, (c) => {
          if (c.members.length !== 0) {
            return <Node o={c} parent={props.o} />;
          }
        })}
    </T>
  );
}
const theme = createTheme({
  // palette: {
  //   background: "#ECECF4",
  // },
  fontFamily: "Roboto, sans-serif",
});

export const OrganizationalChart = forwardRef((props, ref) => {

  const dispatch = useDispatch();

  let orglist = useSelector(state => state.fetchChartData_Reducer.structureList);

  let [isPublic, setIsPublic] = useState(false);

  const handleChange = (e) => {
    setIsPublic(e.target.checked);
    dispatch(fetchChartData(isPublic));
  }
  useEffect(() => {
    dispatch(fetchChartData(isPublic));
    // dispatch(loadReportingManagers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPublic]);
  return (
    <>
      <ThemeProvider theme={theme}>
        <div style={{ float: "right" }}>
          <FormControlLabel
            className="floating-btn"
            control={
              <Switch
                name="viewAll"
                color="primary"
                size="small"
                checked={isPublic}
                onChange={handleChange}
                className="radio-org"
              />
            }
            label="View All Users"
          />
        </div>
        <Box padding={4}>
          <DndProvider backend={HTML5Backend}>
            <Node o={orglist} />
          </DndProvider>
        </Box>
      </ThemeProvider>
    </>
  );
});
